<template>
  <div class="notice-page p-4">
    <!-- Notices list -->
    <div class="content-container" v-infinite-scroll="fetchNextPage">
      <el-card v-for="n in notices" :key="n.id" class="mb-3 notice-card" shadow="hover">
        <template #header>
          <div class="notice-header">
            <strong>{{ n.title ? n.title : "<No Subject>" }}</strong>
          </div>
        </template>

        <div class="notice-content mt-2">
          <span class="multi-line">{{ n.content }}</span>
          <br />
          <span class="date">{{ formatDate(n.updatedAt) }}</span>
          <span class="issuer">By {{ n.issurer || 'Unknown' }}</span>
        </div>
      </el-card>
      <div v-if="!notices || notices.length === 0" class="no-data">No data.</div>
    </div>

    <!-- <div class="pagination-container">
      <el-pagination v-model:current-page="pagination.currentPage" v-model:page-size="pagination.pageSize"
        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div> -->
  </div>
</template>


<script>
import { useUserStore } from '../stores/Global.js';
import axios from 'axios';
import { BACKEND_URL } from '../../../share-source/src/config/config.js';

export default {
  name: 'NoticeView',
  
  setup() {
    const userStore = useUserStore();
    return {
      userStore
    }
  },
  data() {
    return {
      notices: [],
      dialogVisible: false,
      editing: {
        title: "",
        content: "",
        id: null
      },
      pagination: {
        currentPage: -1,
        pageSize: 5,
        total: 0
      },
      hasMore: true
    }
  },
  created() {
    // this.fetch();
  },
  methods: {
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetch();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetch();
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString();
    },

    async fetchNextPage() {
        // console.log('fetchNextPage');
        if (!this.hasMore) return;

        this.pagination.currentPage += 1;
        this.fetch();
    },
    fetch() {
        const params = new URLSearchParams();
        params.append('page', this.pagination.currentPage);
        params.append('size', this.pagination.pageSize);

        axios.get(`${BACKEND_URL}/api/notice/paged`, {params}).then(rsp => {
            this.notices.push(...rsp.data.content);
            this.pagination.total = rsp.data.totalElements;
            this.pagination.currentPage = rsp.data.number;
            this.hasMore = !rsp.data.last;
        }).catch(err => {
            console.log(err);
            this.pagination.total = 0;
            this.pagination.currentPage = 0;
            this.notices = [];
        })
    },
  }
}
</script>

<style scoped>
.notice-card {
  border-radius: 10px;
  padding: 10px;
  margin: 10px;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: visible;
  /* overflow: scroll; */
}
.notice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.issuer {
  font-size: 0.9em;
  color: #888;
  float: right;
}
.date {
  font-size: 0.85em;
  color: #aaa;
  float: right;
  margin-left: 10px;
}
.global-action {
  float: right;
}
.sub-action {
  float: right;
  margin: 10px;
}
.notice-page {
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  /* overflow: auto; */
}
.content-container {
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
}
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.multi-line {
  white-space: pre-wrap;
  word-break: break-word;
}
.no-data {
  display: flex;                 /* enable flex layout */
  justify-content: center;       /* horizontal center */
  align-items: center;           /* vertical center */
  height: 100vh;                 /* full viewport height */
  font-size: 36px;               /* large font */
  color: #888;                   /* optional gray color */
  font-weight: bold;             /* make it bold */
}
</style>